import { render, staticRenderFns } from "./editMaterial.vue?vue&type=template&id=07d42217"
import script from "./editMaterial.vue?vue&type=script&lang=js"
export * from "./editMaterial.vue?vue&type=script&lang=js"
import style0 from "./editMaterial.vue?vue&type=style&index=0&id=07d42217&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports